<template>
  <div class="page">
    <p style="text-align: center; margin-bottom: 20px">
      <img src="https://wisuda.pspp-integrated.com/logo.jpeg" width="120" />
    </p>

    <h3>{{ user.nama }}</h3>

    <button @click="connect">
      {{ printer ? "Tersambung : RPP-02N" : "Connect Printer" }}
    </button>
    <br />
    <br />
    <div class="menu">
      <router-link to="/pengambilan">
        <p>
          Ambil Toga & Deposit <br />
          <b>({{ sum.validasi }})</b>
        </p>
      </router-link>
      <router-link to="/validasi-deposit">
        <p>
          Validasi Deposit<br />
          <b>({{ sum.deposit }})</b>
        </p>
      </router-link>
      <router-link to="/validasi-toga">
        <p>
          Validasi Toga <br />
          <b>({{ sum.toga }})</b>
        </p>
      </router-link>
      <router-link to="/checkin">
        <p>
          Checkin Wisuda
          <br />
          <b>({{ sum.checkin }})</b>
        </p>
      </router-link>
      <router-link to="/peserta">
        <p>
          Wisudawan
          <br />
          <b>({{ sum.checkin }})</b>
        </p>
      </router-link>
      <router-link to="/sertifikat">
        <p>
          Ambil Sertifikat
          <br />
          <b>({{ sum.sertifikat }})</b>
        </p>
      </router-link>
    </div>

    <!-- <button @click="share()">share</button> -->

    <p style="font-size: 14px;">
      Versi: 1.2.0
    </p>
  </div>
</template>

<script>
import * as api from "./../api";
export default {
  name: "app",
  data() {
    return {
      printer: false,
      user: JSON.parse(localStorage.getItem("login")),
      sum: {
        deposit: 0,
        toga: 0,
        validasi: 0,
        checkin: 0,
        sertifikat: 0,
      },
      downloading: false,
      countDownload: 0,
      totalPeserta: 0,
    };
  },
  methods: {
    load() {
      api.get("/v1/wisuda/CheckinController/summaryDepositToga").then((r) => {
        if (r.valid) {
          this.sum.deposit = r.data.jumlah_deposit;
          this.sum.toga = r.data.jumlah_toga;
          this.sum.validasi = r.data.jumlah_validasi;
          this.sum.checkin = r.data.jumlah_checkin;
          this.sum.sertifikat = r.data.jumlah_sertifikat;
        }
      });
    },
    connect() {
      window.plugins.toast.showLongBottom("Connecting...");
      window.setTimeout(() => {
        /* Use timeout to properly update GUI first */
        const printer = "RPP-02N";
        BTPrinter.connect(
          (data) => {
            BTPrinter.printText(
              (data) => {
                window.plugins.toast.showShortBottom("Connected");
                this.printer = true;
              },
              (err) => {
                window.plugins.toast.showShortBottom(
                  "Failed to connect: " + err
                );
              },
              "\n\n"
            );
          },
          (err) => {},
          printer
        );
      }, 150);
    },
    download() {
      this.downloading = true;
      api
        .get("/v1/wisuda/CheckinController/downloadPeserta")
        .then((r) => {
          this.downloading = false;

          if (r.valid) {
            this.$store.commit("peserta/save", r.data);
          }
        })
        .catch((e) => {
          this.downloading = false;
        });
    },
    share() {
      const data = {
        title: 'Hel',
        text: 'Heloooo',
        url: 'https://restoku.id',
      }

      if (navigator.canShare && navigator.canShare(data)) {
        navigator.share(data)
      }
    }
  },
  mounted() {
    this.download();
    this.load();
  },
};
</script>

<style lang="scss" scoped>
.page {
  .menu {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-row-gap: 15px;
    grid-column-gap: 15px;

    a {
      text-decoration: none;
      color: #333;
      border: 1px solid #999;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      height: 100px;
      text-transform: uppercase;
      font-size: 14px;
      padding: 0 20px;
      &:active {
        background-color: #eee;
      }
    }

    div {
      border: 1px solid #999;
      padding: 15px;
      h3 {
        margin: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue